export const camelToSnake = (str: string) => {
    if (typeof str !== 'string') return str;

    return str
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1_$2')
        .replace(/[\s-]+/g, '_')
        .toLowerCase();
};

export const keysToSnakeObject = <T>(input: T): T => {
    if (Array.isArray(input)) return input.map(keysToSnakeObject) as unknown as T;
    if (input && typeof input === 'object' && input.constructor === Object) {
        const out = {} as T;
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(input)) {
            // @ts-ignore
            out[camelToSnake(key)] = keysToSnakeObject(value);
        }
        return out;
    }
    return input;
};
